import { memo, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import styles from "./PeriodCell.module.css";

const PeriodCell = memo(({ day, period, logs, teachers, onClick }) => {
	const isMissing = logs.length === 0;
	const hasDuplicates = logs.length > 1;

	const teacherNamesMap = useMemo(() => {
		if (!teachers) return {};
		const map = {};
		teachers.forEach((teacher) => {
			map[teacher.id] = teacher.firstName.split(" ")[0];
		});
		return map;
	}, [teachers]);

	const getTeacherName = (teacherId) => {
		return teacherNamesMap[teacherId] || "Unknown";
	};

	const handleClick = () => {
		if (isMissing) {
			onClick("addLog", { date: day.dateFormatted, period });
		} else {
			onClick("viewDetails", logs[0]);
		}
	};

	return (
		<div
			className={`${styles.dayCell} ${isMissing ? styles.missing : ""} ${
				hasDuplicates ? styles.duplicate : ""
			} ${day.isToday ? styles.today : ""}`}
			onClick={handleClick}
		>
			{isMissing ? (
				<div className={styles.missingLog}>
					<span className={styles.addIcon}>+</span>
					<span>Add</span>
				</div>
			) : (
				<div className={styles.logEntry}>
					<div className={styles.logTitle} title={logs[0].lectureTitle}>
						{logs[0].lectureTitle}
					</div>
					<div className={styles.logDetails}>
						<span className={styles.sequence}>#{logs[0].sequence}</span>
						<span className={styles.teacher}>
							<FontAwesomeIcon icon={faUser} />
							{getTeacherName(logs[0].teacherId)}
						</span>
					</div>
					{hasDuplicates && (
						<div
							className={styles.duplicateIndicator}
							title={`Multiple entries (${logs.length})`}
						>
							<FontAwesomeIcon icon={faInfoCircle} />
							<span>{logs.length}</span>
						</div>
					)}
				</div>
			)}
		</div>
	);
});

export default PeriodCell;
